import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Admin forms record other people's details, so browser autofill and password
 * managers only ever offer the signed-in admin's own name, email or address.
 * Everything opts out by default; the few fields that want autofill (login) pass
 * an explicit `autoComplete` and get the ignore hints dropped along with it.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, autoComplete = 'off', ...props }, ref) => {
    const optedOut = autoComplete === 'off';
    return (
      <input
        type={type}
        autoComplete={autoComplete}
        data-1p-ignore={optedOut ? '' : undefined}
        data-lpignore={optedOut ? 'true' : undefined}
        data-form-type={optedOut ? 'other' : undefined}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
